var map = {
	"./01.jpg": 43217,
	"./02.jpg": 85446,
	"./03.jpg": 66499,
	"./04.jpg": 35344,
	"./05.jpg": 78797,
	"./06.jpg": 30306,
	"./07.jpg": 66655,
	"./08.jpg": 22556,
	"./09.jpg": 36281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28055;